//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MenuTree',
  props: {
    treeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isShowUserCount: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      defaultFrame: []
    };
  },
  watch: {
    treeData: {
      handler: function handler(nVal, oVal) {
        var _this = this;
        this.$nextTick(function () {
          if (nVal.length) {
            var value = nVal[0].value;
            _this.defaultFrame = [value];
            _this.$refs.tree.setCurrentKey(value);
          }
        });
      },
      deep: true
    },
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    // tree节点点击
    handleClick: function handleClick(node, data) {
      this.$emit('frameId', node.$treeNodeId === 1 ? '' : node.value);
    },
    // tree搜索过滤
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }
  }
};